export const SERVER_URL = process.env.REACT_APP_IS_PROD === 'true'
    ? 'https://api.reservista.ru'
    : 'https://api-devel.reservista.ru';

export const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';
